<app-allocation-component *ngIf="boPortfolio"
                          [anyPortfolio]="boPortfolio"
></app-allocation-component>
